import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Hourglass01 = function Hourglass01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 12 7.7271 8.4393c-.6348-.529-.9523-.7936-1.1805-1.1179a3 3 0 0 1-.4436-.9471C6 5.9913 6 5.5782 6 4.7518V2m6 10 4.2729-3.5607c.6348-.529.9523-.7936 1.1805-1.1179a3 3 0 0 0 .4436-.9471C18 5.9913 18 5.5782 18 4.7518V2m-6 10-4.2729 3.5607c-.6348.5291-.9523.7936-1.1805 1.1179a3 3 0 0 0-.4436.9471C6 18.0086 6 18.4218 6 19.2482V22m6-10 4.2729 3.5607c.6348.5291.9523.7936 1.1805 1.1179.2022.2873.3523.6079.4436.9471.103.3829.103.7961.103 1.6225V22M4 2h16M4 22h16"
    })
  }));
};
export default Hourglass01;